import { useQuery } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

export interface InboxState {
  id: 1;
  inbox_count: number;
  failed_count: number;
  processed_30d: number;
  synced_at: string;
}

export function useInboxState() {
  return useQuery<InboxState | null>({
    queryKey: ["inbox_state"],
    queryFn: async () => {
      const { data, error } = await supabaseAgency.from("os_inbox_state_cache")
        .select("*").eq("id", 1).maybeSingle();
      if (error) throw error;
      return (data ?? null) as InboxState | null;
    },
  });
}
